import {
  IServiceConnection,
  IUserConnection,
  IReviewConnection,
  IServiceFilters,
  ServiceOrder,
  IUserFilters,
  INotificationConnection,
  INotification,
  IUser,
  IRequestConnection,
  IPreConversationConnection,
  IService,
  IServiceCreateInput,
  IServiceUpdateInput,
  IRequest,
  IRequestCreateInput,
  IConversationReviewInput,
  IConversationMessageConnection,
  IConversationMessageInput,
  IConversationMessage,
  IPreConversationInput,
  IPreConversation,
  ISalesConnection,
  IAccount,
  IAccountUpdateInput,
  IAccountUpdateIdentificationInput,
  ITransactionConnection,
  IBank,
  ICreditCardInput,
  IWithdrawalInput,
  ISales,
} from "./domains";
import { API, graphqlOperation } from "aws-amplify";
import { GRAPHQL_AUTH_MODE } from "@aws-amplify/auth";
import Observable from "zen-observable-ts";

export const QueryGetServices = `
  query GetServices(
    $filter: ServiceFilters
    $order: ServiceOrder
    $limit: Int
    $offset: Int
  ) {
    getServices(
      filter: $filter
      order: $order
      limit: $limit
      offset: $offset
    ) {
      items {
        id
        title
        images
        mainImageUrl
        price
        isBlocked
        isLiked
        usages
        rate
        rateCount
        averageTime
        isDisabled        
        owner {
          id
          name
          image
          minutesFromLastLogin
          status
          identificationStatus
        }
        category {
          title
        }
        likeCount
      }
      totalCount
    }
  }
`;

export const QueryGetUsers = `
  query GetUsers($filter: UserFilters, $limit: Int, $offset: Int) {
    getUsers(filter: $filter, limit: $limit, offset: $offset) {
      items {
        id
        name
        image
        gender
        birthday
        address {
          postnumber
          prefecture
          city
          address
          address2
          address3
        }
        isBlocked
        status
        identificationStatus
      }
      totalCount
    }
  }
`;

export const QueryGetReviewsByUserAsUser = `
  query GetReviewsByUserAsUser(
    $userId: ID!
    $limit: Int
    $offset: Int
    $withComment: Boolean
  ) {
    getReviewsByUserAsUser(
      userId: $userId
      limit: $limit
      offset: $offset
      withComment: $withComment
    ) {
      items {
        id
        rate
        comment
        createdAt

        owner {
          id
          name
          image
          minutesFromLastLogin
          status
          identificationStatus
        }

        service {
          id
          title
          price
        }
      }
    }
  }
`;

export const QueryGetReviewsByUserAsServiceOwner = `
  query GetReviewsByUserAsServiceOwner(
    $userId: ID!
    $limit: Int
    $offset: Int
    $withComment: Boolean
  ) {
    getReviewsByUserAsServiceOwner(
      userId: $userId
      limit: $limit
      offset: $offset
      withComment: $withComment
    ) {
      items {
        id
        rate
        comment
        createdAt

        owner {
          id
          name
          image
          minutesFromLastLogin
          status
          identificationStatus
        }

        service {
          id
          title
          price
        }
      }
    }
  }
`;

export const QueryGetNotifications = `
  query {
    getNotifications {
      items {
        id
        userId
        title
        details
        isUnread
        createdAt
      }
      totalCount
    }
  }
`;

export const QueryGetNotification = `
  query GetNotification($id: ID!) {
    getNotification(id: $id) {
      id
      userId
      title
      details
      isUnread
      createdAt
    }
  }
`;

export const QueryGetNotificationsUnreadCount = `
  query {
    getNotificationsUnreadCount
  }
`;

export const QueryGetReviewsByService = `
  query GetReviewsByService(
    $serviceId: ID!
    $limit: Int
    $offset: Int
    $withComment: Boolean
  ) {
    getReviewsByService(
      serviceId: $serviceId
      limit: $limit
      offset: $offset
      withComment: $withComment
    ) {
      items {
        id
        rate
        comment
        createdAt
        owner {
          id
          name
          image
          minutesFromLastLogin
          status
          identificationStatus
        }
      }
    }
  }
`;

export const QueryGetReviewsByServiceToUser = `
  query GetReviewsByServiceToUser(
    $serviceId: ID!
    $limit: Int
    $offset: Int
    $withComment: Boolean
  ) {
    getReviewsByServiceToUser(
      serviceId: $serviceId
      limit: $limit
      offset: $offset
      withComment: $withComment
    ) {
      items {
        id
        rate
        comment
        createdAt
        owner {
          id
          name
          image
          minutesFromLastLogin
          status
          identificationStatus
        }
      }
    }
  }
`;

export const QueryGetUser = `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      name
      image
      gender
      birthday
      address {
        postnumber
        prefecture
        city
        address
        address2
        address3
      }
      aboutTalk
      aboutProfile
      description
      voice
      minutesFromLastLogin
      status

      isBlocked
      isOwnBlocked
      rateCount
      rate
      createdAt
      lastLoginAt
      identificationStatus
    }
  }
`;

export const QueryGetRequests = `
  query {
    getRequests {
      items {
        id
        senderId
        opponentId
        serviceId
        status
        createdAt
        startedAt
        rejectedAt
        finishedAt
        expiredAt
        price
        freeTime
        maxTalkingTimeBefore
        service {
          id
          title
          price
        }
        sender {
          id
          name
          isBlocked
          image
          minutesFromLastLogin
          status
          identificationStatus
        }
        opponent {
          id
          name
          isBlocked
          image
          minutesFromLastLogin
          status
          identificationStatus
        }
        senderReview {
          id
        }
        opponentReview {
          id
        }
      }
    }
  }
`;

export const QueryGetPreConversations = `
  query {
    getPreConversations {
      items {
        id
        senderId
        opponentId
        serviceId
        updatedAt
        service {
          id
          title
        }
        sender {
          id
          name
          image
          isBlocked
          image
          minutesFromLastLogin
          status
          identificationStatus
        }
        opponent {
          id
          name
          image
          isBlocked
          image
          minutesFromLastLogin
          status
          identificationStatus
        }
        lastReceivedMessage {
          createdAt
          readAt
        }
        lastMessage {
          createdAt
          readAt
        }
      }
    }
  }
`;

export const QueryGetPreConversation = `
  query GetPreConversation($id: ID!) {
    getPreConversation(id: $id) {
      id
      senderId
      opponentId
      serviceId
      updatedAt
      service {
        id
        title
      }
      sender {
        id
        name
        image
        isBlocked
        image
        minutesFromLastLogin
        status
        identificationStatus
      }
      opponent {
        id
        name
        image
        isBlocked
        image
        minutesFromLastLogin
        status
        identificationStatus
      }
      lastReceivedMessage {
        createdAt
        readAt
      }
    }
  }
`;

export const QueryGetPreConversationByService = `
  query GetPreConversationByService($serviceId: ID!) {
    getPreConversationByService(serviceId: $serviceId) {
      id
      senderId
      opponentId
      serviceId
      updatedAt
      service {
        id
        title
      }
      sender {
        id
        name
        image
        isBlocked
        image
        minutesFromLastLogin
        status
        identificationStatus
      }
      opponent {
        id
        name
        image
        isBlocked
        image
        minutesFromLastLogin
        status
        identificationStatus
      }
      lastReceivedMessage {
        createdAt
        readAt
      }
    }
  }
`;

export const QueryGetService = `
  query GetService($id: ID!) {
    getService(id: $id) {
      id
      title
      description
      images
      mainImageUrl
      price
      isPublic
      isBlocked
      isLiked
      usages
      rate
      rateCount
      averageTime
      createdAt
      updatedAt
      isDisabled
      ownerId
      owner {
        id
        name
        image
        minutesFromLastLogin
        status
        identificationStatus
        lastLoginAt
      }
      category {
        id
        title
      }
      likeCount
    }
  }
`;

export const QueryGetOwnServices = `
  query GetOwnServices($limit: Int, $offset: Int) {
    getOwnServices(limit: $limit, offset: $offset) {
      items {
        id
        title
        description
        images
        mainImageUrl
        price
        isPublic
        isBlocked
        isLiked
        usages
        rate
        rateCount
        averageTime
        createdAt
        isDisabled
        owner {
          id
          name
          image
          minutesFromLastLogin
          status
          identificationStatus
        }
        category {
          id
          title
        }
        likeCount
        views
      }
      totalCount
    }
  }
`;

export const QueryGetRequest = `
  query GetRequest($id: ID!) {
    getRequest(id: $id) {
      id
      senderId
      opponentId
      serviceId
      status
      createdAt
      waitingTime
      message
      offerRejectMessage
      offerCancelMessage
      startedAt
      rejectedAt
      finishedAt
      expiredAt
      price
      freeTime
      maxTalkingTimeBefore
      service {
        id
        title
        price
        isActive
      }
      sender {
        id
        name
        isBlocked
        identificationStatus
      }
      opponent {
        id
        name
        isBlocked
        identificationStatus
      }
      senderReview {
        id
        rate
        comment
        createdAt
        owner {
          id
          name
          image
          minutesFromLastLogin
          status
          identificationStatus
        }
      }
      opponentReview {
        id
        rate
        comment
        createdAt
        owner {
          id
          name
          image
          minutesFromLastLogin
          status
          identificationStatus
        }
      }
    }
  }
`;

export const QueryGetActiveRequest = `
  query Test {
    getActiveRequest {
      id
      senderId
      opponentId
      serviceId
      status
      createdAt
      waitingTime
      message
      offerRejectMessage
      offerCancelMessage
      startedAt
      rejectedAt
      finishedAt
      expiredAt
      price
      freeTime
      maxTalkingTimeBefore
      service {
        id
        title
        price
      }
      sender {
        id
        name
        isBlocked
        identificationStatus
      }
      opponent {
        id
        name
        isBlocked
        identificationStatus
      }
    }
  }
`;

export const QueryGetRequestTwilioToken = `
  query GetRequestTwilioToken($id: ID!) {
    getRequestTwilioToken(id: $id)
  }
`;

export const QueryGetConversationMessages = `
  query GetConversationMessages($id: ID!, $first: Int, $after: String) {
    getConversationMessages(id: $id, first: $first, after: $after) {
      items {
        id
        ownerId
        opponentId
        content {
          text
          image
        }
        createdAt
        readAt
      }
      nextToken
    }
  }
`;

export const QueryGetUnreadMessages = `
  query {
    getUnreadMessages {
      items {
        id
        conversationId
        ownerId
        opponentId
        createdAt
        readAt
      }
      nextToken
    }
  }
`;

export const QueryGetSales = `
  query {
    getSales {
      items {
        id
        userId
        requestId
        type

        amount
        requestAmount
        systemFee
        validationFee
        approveFee
        rejectFee
        errorFee
        processingFee
        transferAmount

        transferAt
        createdAt

        bankCode
        bankName
        bankBranchCode
        bankBranchName
        bankAccountType
        bankAccountNumber
        bankAccountHolder

        request {
          id
          service {
            id
            title
            price
          }
        }
      }
    }
  }
`;

export const QueryGetAccount = `
  query {
    getAccount {
      id
      name
      image
      fullName
      gender
      birthday
      address {
        postnumber
        prefecture
        city
        address
        address2
        address3
      }
      aboutTalk
      aboutProfile
      description
      voice
      phone
      balance
      sales
      bank {
        bankCode
        bankName
        branchCode
        branchName
        accountType
        accountHolder
        accountNumber
      }
      identificationStatus
      identificationMessage
      identificationDocuments
      stipeCard
      stipeExpired
      isDisabled
    }
  }
`;

export const QueryGetTransactions = `
  query {
    getTransactions {
      items {
        id
        type
        amount
        createdAt
      }
    }
  }
`;

export const QueryGetBanks = `
  query {
    getBanks {
      id
      name
      kana
      hira
      roma
    }
  }
`;

export const QueryGetBank = `
  query GetBank($id: ID!) {
    getBank(id: $id) {
      id
      name
      kana
      hira
      roma

      branches {
        id
        code
        bankId
        name
        kana
        hira
        roma
      }
    }
  }
`;

export const QueryGetWithdrawalRequest = `
  query GetWithdrawalRequest($id: ID!) {
    getWithdrawalRequest(id: $id) {
      id
      userId
      requestId
      type

      amount
      requestAmount
      systemFee
      validationFee
      approveFee
      rejectFee
      errorFee
      processingFee
      transferAmount

      transferAt
      createdAt

      bankCode
      bankName
      bankBranchCode
      bankBranchName
      bankAccountType
      bankAccountNumber
      bankAccountHolder
    }
  }
`;

export const QueryGetRequestUnreadCount = `
  query {
    getRequestUnreadCount
  }
`;

export const QueryGetPreConversationsUnreadCount = `
  query {
    getPreConversationsUnreadCount
  }
`;

export const MutationServiceCreate = `
  mutation ServiceCreate($input: ServiceCreateInput!) {
    serviceCreate(input: $input) {
      id
      title
      mainImageUrl
      images
      description
      categoryId
      isDisabled
      price
      owner {
        name
        identificationStatus
      }
    }
  }
`;

export const MutationServiceUpdate = `
  mutation ServiceUpdate($input: ServiceUpdateInput!) {
    serviceUpdate(input: $input) {
      id
      title
      mainImageUrl
      images
      description
      categoryId
      price
      isDisabled
      owner {
        name
        identificationStatus
      }
    }
  }
`;

export const MutationServiceDelete = `
  mutation ServiceDelete($id: ID!) {
    serviceDelete(id: $id) {
      id
    }
  }
`;

export const MutationServiceLike = `
  mutation ServiceLike($id: ID!) {
    serviceLike(id: $id)
  }
`;

export const MutationServiceDislike = `
  mutation ServiceDislike($id: ID!) {
    serviceDislike(id: $id)
  }
`;

export const MutationServiceView = `
  mutation ServiceView($id: ID!) {
    serviceView(id: $id) {
      serviceId
      userId
    }
  }
`;

export const MutationUserBlock = `
  mutation UserBlock($id: ID!) {
    userBlock(id: $id)
  }
`;

export const MutationUserUnblock = `
  mutation UserUnblock($id: ID!) {
    userUnblock(id: $id)
  }
`;

export const MutationNotificationRead = `
  mutation NotificationRead($id: ID!) {
    notificationRead(id: $id)
  }
`;

export const MutationRequestCreate = `
  mutation RequestCreate($input: RequestCreateInput!) {
    requestCreate(input: $input) {
      id
      senderId
      opponentId
      serviceId
      status
      waitingTime
      price
      message
      offerRejectMessage
      offerCancelMessage
      createdAt
      startedAt
      rejectedAt
      finishedAt
      expiredAt
      freeTime
      maxTalkingTimeBefore
    }
  }
`;

export const MutationRequestApprove = `
  mutation RequestApprove($id: ID!, $requestTimestamp: String) {
    requestApprove(id: $id, requestTimestamp: $requestTimestamp) {
      id
      senderId
      opponentId
      serviceId
      status
      waitingTime
      price
      message
      offerRejectMessage
      offerCancelMessage
      createdAt
      startedAt
      rejectedAt
      finishedAt
      expiredAt
      freeTime
      maxTalkingTimeBefore
    }
  }
`;

export const MutationRequestCancel = `
  mutation RequestCancel($id: ID!, $offerCancelMessage: String) {
    requestCancel(id: $id, offerCancelMessage: $offerCancelMessage) {
      id
      senderId
      opponentId
      serviceId
      status
      waitingTime
      price
      message
      offerRejectMessage
      offerCancelMessage
      createdAt
      startedAt
      rejectedAt
      finishedAt
      expiredAt
      freeTime
      maxTalkingTimeBefore
    }
  }
`;

export const MutationRequestReject = `
  mutation RequestReject($id: ID!, $offerRejectMessage: String) {
    requestReject(id: $id, offerRejectMessage: $offerRejectMessage) {
      id
      senderId
      opponentId
      serviceId
      status
      waitingTime
      price
      message
      offerRejectMessage
      offerCancelMessage
      createdAt
      startedAt
      rejectedAt
      finishedAt
      expiredAt
      freeTime
      maxTalkingTimeBefore
    }
  }
`;

export const MutationRequestCallApprove = `
  mutation RequestCallApprove($id: ID!) {
    requestCallApprove(id: $id) {
      id
      senderId
      opponentId
      serviceId
      status
      waitingTime
      price
      message
      offerRejectMessage
      offerCancelMessage
      createdAt
      startedAt
      rejectedAt
      finishedAt
      expiredAt
      freeTime
      maxTalkingTimeBefore
    }
  }
`;

export const MutationRequestCallReject = `
  mutation RequestCallReject($id: ID!) {
    requestCallReject(id: $id) {
      id
      senderId
      opponentId
      serviceId
      status
      waitingTime
      price
      message
      offerRejectMessage
      offerCancelMessage
      createdAt
      startedAt
      rejectedAt
      finishedAt
      expiredAt
      freeTime
      maxTalkingTimeBefore
    }
  }
`;

export const MutationRequestCallFinish = `
  mutation RequestCallFinish($id: ID!) {
    requestCallFinish(id: $id) {
      id
      senderId
      opponentId
      serviceId
      status
      waitingTime
      price
      message
      offerRejectMessage
      offerCancelMessage
      createdAt
      startedAt
      rejectedAt
      finishedAt
      expiredAt
      freeTime
      maxTalkingTimeBefore
    }
  }
`;

export const MutationRequestTimeout = `
  mutation RequestTimeout($id: ID!) {
    requestTimeout(id: $id) {
      id
      senderId
      opponentId
      serviceId
      status
      waitingTime
      price
      message
      offerRejectMessage
      offerCancelMessage
      createdAt
      startedAt
      rejectedAt
      finishedAt
      expiredAt
      freeTime
      maxTalkingTimeBefore
    }
  }
`;

export const MutationRequestReoffer = `
  mutation RequestReoffer($id: ID!) {
    requestReoffer(id: $id) {
      id
      senderId
      opponentId
      serviceId
      status
      waitingTime
      price
      message
      offerRejectMessage
      offerCancelMessage
      createdAt
      startedAt
      rejectedAt
      finishedAt
      expiredAt
      freeTime
      maxTalkingTimeBefore
    }
  }
`;

export const MutationConversationReview = `
  mutation ConversationReview($input: ConversationReviewInput!) {
    conversationReview(input: $input)
  }
`;

export const MutationConversationMessage = `
  mutation ConversationMessage(
    $input: ConversationMessageInput
    $type: String
  ) {
    conversationMessage(input: $input, type: $type) {
      id
      ownerId
      conversationId
      opponentId
      content {
        text
        image
      }
      createdAt
      readAt
    }
  }
`;

export const MutationConversationMessageRead = `
  mutation ConversationMessageRead($id: ID!) {
    conversationMessageRead(id: $id) {
      id
      ownerId
      conversationId
      opponentId
      content {
        text
        image
      }
      createdAt
      readAt
    }
  }
`;

export const MutationPreConversationCreate = `
  mutation preConversationCreate($input: PreConversationInput!) {
    preConversationCreate(input: $input) {
      id
      senderId
      opponentId
      serviceId
      updatedAt
      service {
        id
        title
        price
      }
      sender {
        id
        name
        image
        isBlocked
        identificationStatus
      }
      opponent {
        id
        name
        image
        isBlocked
        identificationStatus
      }
      lastReceivedMessage {
        createdAt
      }
    }
  }
`;

export const MutationRegisterPushToken = `
  mutation RegisterPushToken($token: String!) {
    registerPushToken(token: $token)
  }
`;

export const MutationRegisterPushVoipToken = `
  mutation RegisterPushVoipToken($token: String!) {
    registerPushVoipToken(token: $token)
  }
`;

export const MutationResetPushTokens = `
  mutation {
    resetPushTokens
  }
`;

export const MutationAccountUpdate = `
  mutation AccountUpdate($input: AccountUpdateInput!) {
    accountUpdate(input: $input) {
      name
      image
      fullName
      gender
      birthday
      address {
        postnumber
        prefecture
        city
        address
        address2
        address3
      }
      aboutTalk
      aboutProfile
      description
      voice
      phone
      identificationStatus
    }
  }
`;

export const MutationAccountUpdateIdentification = `
  mutation AccountUpdateIdentification(
    $input: AccountUpdateIdentificationInput!
  ) {
    accountUpdateIdentification(input: $input)
  }
`;

export const MutationAccountSignOut = `
  mutation {
    accountSignOut
  }
`;

export const MutationAccountRemove = `
  mutation {
    accountRemove
  }
`;

export const MutationAccountPhoneConfirm = `
  mutation AccountPhoneConfirm($phone: String!) {
    accountPhoneConfirm(phone: $phone)
  }
`;

export const MutationAccountUpdatePhone = `
  mutation AccountUpdatePhone($phone: String!, $code: String!) {
    accountUpdatePhone(phone: $phone, code: $code)
  }
`;

export const MutationTransactionBuy = `
  mutation TransactionBuy($code: String!) {
    transactionBuy(code: $code)
  }
`;

export const MutationTransactionCreditCard = `
  mutation TransactionCreditCard($input: CreditCardInput!) {
    transactionCreditCard(input: $input)
  }
`;

export const MutationAccountUpdateLastLogin = `
  mutation {
    accountUpdateLastLogin
  }
`;

export const MutationWithdrawal = `
  mutation Withdrawal($input: WithdrawalInput!) {
    withdrawal(input: $input)
  }
`;

export const MutationAccountIsNicknameExist = `
  mutation AccountIsNicknameExist($nickname: String!) {
    accountIsNicknameExist(nickname: $nickname)
  }
`;

export const MutationAccountTimestampValidation = `
  mutation AccountTimestampValidation($timestamp: String!) {
    accountTimestampValidation(timestamp: $timestamp)
  }
`;

export const MutationRequestsRead = `
  mutation {
    requestsRead
  }
`;

export const MutationAttachToIot = `
  mutation attachToIot($identityId: String!) {
    attachToIot(identityId: $identityId)
  }
`;

export const SubscriptionOnRequestSender = `
  subscription OnRequestSender($senderId: ID!) {
    onRequestSender(senderId: $senderId) {
      id
      senderId
      opponentId
      serviceId
      status
      waitingTime
      price
      message
      offerRejectMessage
      offerCancelMessage
      createdAt
      startedAt
      rejectedAt
      finishedAt
      expiredAt
      freeTime
      maxTalkingTimeBefore
    }
  }
`;

export const SubscriptionOnRequestOpponent = `
  subscription OnRequestOpponent($opponentId: ID!) {
    onRequestOpponent(opponentId: $opponentId) {
      id
      senderId
      opponentId
      serviceId
      status
      waitingTime
      price
      message
      offerRejectMessage
      offerCancelMessage
      createdAt
      startedAt
      rejectedAt
      finishedAt
      expiredAt
      freeTime
      maxTalkingTimeBefore
    }
  }
`;

export const SubscriptionOnConversationMessage = `
  subscription OnConversationMessage($conversationId: ID!) {
    onConversationMessage(conversationId: $conversationId) {
      id
      ownerId
      opponentId
      content {
        text
        image
      }
      createdAt
      readAt
    }
  }
`;

export const SubscriptionOnConversationMessageOpponent = `
  subscription OnConversationMessageOpponent($opponentId: ID!) {
    onConversationMessageOpponent(opponentId: $opponentId) {
      id
      conversationId
      ownerId
      opponentId
      content {
        text
        image
      }
      createdAt
      readAt
    }
  }
`;

export interface IGraphQLError {
  path?: string[];
  data?: any;
  errorType?: string;
  errorInfo?: any;
  locations?: any;
  message: string;
}

export interface IQueryGetServicesRequest {
  filter?: IServiceFilters;
  order?: ServiceOrder;
  limit?: number;
  offset?: number;
}

export interface IQueryGetServicesResponse {
  data: {
    getServices?: IServiceConnection | undefined;
  };
  errors?: IGraphQLError[];
}

export interface IQueryGetUsersRequest {
  filter?: IUserFilters;
  limit?: number;
  offset?: number;
}

export interface IQueryGetUsersResponse {
  data: {
    getUsers?: IUserConnection | undefined;
  };
  errors?: IGraphQLError[];
}

export interface IQueryGetReviewsByUserAsUserRequest {
  userId: string;
  limit?: number;
  offset?: number;
  withComment?: boolean;
}

export interface IQueryGetReviewsByUserAsUserResponse {
  data: {
    getReviewsByUserAsUser?: IReviewConnection | undefined;
  };
  errors?: IGraphQLError[];
}

export interface IQueryGetReviewsByUserAsServiceOwnerRequest {
  userId: string;
  limit?: number;
  offset?: number;
  withComment?: boolean;
}

export interface IQueryGetReviewsByUserAsServiceOwnerResponse {
  data: {
    getReviewsByUserAsServiceOwner?: IReviewConnection | undefined;
  };
  errors?: IGraphQLError[];
}

export interface IQueryGetNotificationsResponse {
  data: {
    getNotifications?: INotificationConnection;
  };
  errors?: IGraphQLError[];
}

export interface IQueryGetNotificationRequest {
  id: string;
}

export interface IQueryGetNotificationResponse {
  data: {
    getNotification?: INotification;
  };
  errors?: IGraphQLError[];
}

export interface IQueryGetNotificationsUnreadCountResponse {
  data: {
    getNotificationsUnreadCount?: number;
  };
  errors?: IGraphQLError[];
}

export interface IQueryGetReviewsByServiceRequest {
  serviceId: string;
  limit?: number;
  offset?: number;
  withComment?: boolean;
}

export interface IQueryGetReviewsByServiceResponse {
  data: {
    getReviewsByService?: IReviewConnection;
  };
  errors?: IGraphQLError[];
}

export interface IQueryGetReviewsByServiceToUserRequest {
  serviceId: string;
  limit?: number;
  offset?: number;
  withComment?: boolean;
}

export interface IQueryGetReviewsByServiceToUserResponse {
  data: {
    getReviewsByServiceToUser?: IReviewConnection;
  };
  errors?: IGraphQLError[];
}

export interface IQueryGetUserRequest {
  id: string;
}

export interface IQueryGetUserResponse {
  data: {
    getUser?: IUser;
  };
  errors?: IGraphQLError[];
}

export interface IQueryGetRequestsResponse {
  data: {
    getRequests?: IRequestConnection;
  };
  errors?: IGraphQLError[];
}

export interface IQueryGetPreConversationsRequest {
  limit?: number;
  offset?: number;
}

export interface IQueryGetPreConversationsResponse {
  data: {
    getPreConversations?: IPreConversationConnection;
  };
  errors?: IGraphQLError[];
}

export interface IQueryGetPreConversationRequest {
  id: string;
}

export interface IQueryGetPreConversationResponse {
  data: {
    getPreConversation?: IPreConversation;
  };
  errors?: IGraphQLError[];
}

export interface IQueryGetPreConversationByServiceRequest {
  serviceId: string;
}

export interface IQueryGetPreConversationByServiceResponse {
  data: {
    getPreConversationByService?: IPreConversation;
  };
  errors?: IGraphQLError[];
}

export interface IQueryGetServiceRequest {
  id: string;
}

export interface IQueryGetServiceResponse {
  data: {
    getService?: IService;
  };
  errors?: IGraphQLError[];
}

export interface IQueryGetOwnServicesRequest {
  limit?: number;
  offset?: number;
}

export interface IQueryGetOwnServicesResponse {
  data: {
    getOwnServices?: IServiceConnection;
  };
  errors?: IGraphQLError[];
}

export interface IQueryGetRequestRequest {
  id: string;
}

export interface IQueryGetRequestResponse {
  data: {
    getRequest?: IRequest;
  };
  errors?: IGraphQLError[];
}

export interface IQueryGetActiveRequestResponse {
  data: {
    getActiveRequest?: IRequest;
  };
  errors?: IGraphQLError[];
}

export interface IQueryGetRequestResponse {
  data: {
    getRequest?: IRequest;
  };
  errors?: IGraphQLError[];
}

export interface IQueryGetActiveRequestResponse {
  data: {
    getActiveRequest?: IRequest;
  };
  errors?: IGraphQLError[];
}

export interface IQueryGetRequestTwilioTokenRequest {
  id: string;
}

export interface IQueryGetRequestTwilioTokenResponse {
  data: {
    getRequestTwilioToken?: string;
  };
  errors?: IGraphQLError[];
}

export interface IQueryGetConversationMessagesRequest {
  id: string;
  first?: number;
  after?: string;
}

export interface IQueryGetConversationMessagesResponse {
  data: {
    getConversationMessages?: IConversationMessageConnection;
  };
  errors?: IGraphQLError[];
}

export interface IQueryGetUnreadMessagesResponse {
  data: {
    getUnreadMessages?: IConversationMessageConnection;
  };
  errors?: IGraphQLError[];
}

export interface IQueryGetSalesResponse {
  data: {
    getSales?: ISalesConnection;
  };
  errors?: IGraphQLError[];
}

export interface IQueryGetAccountResponse {
  data: {
    getAccount?: IAccount;
  };
  errors?: IGraphQLError[];
}

export interface IQueryGetTransactionsResponse {
  data: {
    getTransactions?: ITransactionConnection;
  };
  errors?: IGraphQLError[];
}

export interface IQueryGetBanksResponse {
  data: {
    getBanks?: IBank[];
  };
  errors?: IGraphQLError[];
}

export interface IQueryGetBankRequest {
  id: string;
}

export interface IQueryGetBankResponse {
  data: {
    getBank?: IBank;
  };
  errors?: IGraphQLError[];
}

export interface IQueryGetWithdrawalRequestRequest {
  id: string;
}

export interface IQueryGetWithdrawalRequestResponse {
  data: {
    getWithdrawalRequest?: ISales;
  };
  errors?: IGraphQLError[];
}

export interface IQueryGetRequestUnreadCountResponse {
  data: {
    getRequestUnreadCount?: number;
  };
  errors?: IGraphQLError[];
}

export interface IQueryGetPreConversationsUnreadCountResponse {
  data: {
    getPreConversationsUnreadCount?: number;
  };
  errors?: IGraphQLError[];
}

export interface IMutationServiceCreateRequest {
  input: IServiceCreateInput;
}

export interface IMutationServiceCreateResponse {
  data: {
    serviceCreate?: IService;
  };
  errors?: IGraphQLError[];
}

export interface IMutationServiceUpdateRequest {
  input: IServiceUpdateInput;
}

export interface IMutationServiceUpdateResponse {
  data: {
    serviceUpdate?: IService;
  };
  errors?: IGraphQLError[];
}

export interface IMutationServiceDeleteRequest {
  id: string;
}

export interface IMutationServiceDeleteResponse {
  data: {
    serviceDelete?: IService;
  };
  errors?: IGraphQLError[];
}

export interface IMutationRequestCreateRequest {
  input: IRequestCreateInput;
}

export interface IMutationRequestCreateResponse {
  data: {
    requestCreate?: IRequest;
  };
  errors?: IGraphQLError[];
}

export interface IMutationRequestApproveRequest {
  id: string;
  requestTimestamp?: string;
}

export interface IMutationRequestApproveResponse {
  data: {
    requestApprove?: IRequest;
  };
  errors?: IGraphQLError[];
}

export interface IMutationRequestCancelRequest {
  id: string;
  offerCancelMessage?: string;
}

export interface IMutationRequestCancelResponse {
  data: {
    requestCancel?: IRequest;
  };
  errors?: IGraphQLError[];
}

export interface IMutationRequestRejectRequest {
  id: string;
  offerRejectMessage?: string;
}

export interface IMutationRequestRejectResponse {
  data: {
    requestReject?: IRequest;
  };
  errors?: IGraphQLError[];
}

export interface IMutationRequestCallApproveRequest {
  id: string;
}

export interface IMutationRequestCallApproveResponse {
  data: {
    requestCallApprove?: IRequest;
  };
  errors?: IGraphQLError[];
}

export interface IMutationRequestCallRejectRequest {
  id: string;
}

export interface IMutationRequestCallRejectResponse {
  data: {
    requestCallReject?: IRequest;
  };
  errors?: IGraphQLError[];
}

export interface IMutationRequestCallFinishRequest {
  id: string;
}

export interface IMutationRequestCallFinishResponse {
  data: {
    requestCallFinish?: IRequest;
  };
  errors?: IGraphQLError[];
}

export interface IMutationRequestTimeoutRequest {
  id: string;
}

export interface IMutationRequestTimeoutResponse {
  data: {
    requestTimeout?: IRequest;
  };
  errors?: IGraphQLError[];
}

export interface IMutationRequestReofferRequest {
  id: string;
}

export interface IMutationRequestReofferResponse {
  data: {
    requestReoffer?: IRequest;
  };
  errors?: IGraphQLError[];
}

export interface IMutationConversationReviewRequest {
  input: IConversationReviewInput;
}

export interface IMutationConversationMessageRequest {
  input: IConversationMessageInput;
  type?: string;
}

export interface IMutationConversationMessageResponse {
  data: {
    conversationMessage?: IConversationMessage;
  };
  errors?: IGraphQLError[];
}

export interface IMutationConversationMessageReadRequest {
  id: string;
}

export interface IMutationConversationMessageReadResponse {
  data: {
    conversationMessageRead?: IConversationMessage;
  };
  errors?: IGraphQLError[];
}

export interface IMutationPreConversationCreateRequest {
  input: IPreConversationInput;
}

export interface IMutationPreConversationCreateResponse {
  data: {
    preConversationCreate?: IPreConversation;
  };
  errors?: IGraphQLError[];
}

export interface IMutationRegisterPushTokenRequest {
  token: string;
}

export interface IMutationRegisterPushVoipTokenRequest {
  token: string;
}

export interface IMutationAccountUpdateRequest {
  input: IAccountUpdateInput;
}

export interface IMutationAccountUpdateResponse {
  data: {
    accountUpdate?: any;
  };
  errors?: IGraphQLError[];
}

export interface IMutationAccountUpdateIdentificationRequest {
  input: IAccountUpdateIdentificationInput;
}

export interface IMutationAccountUpdateIdentificationResponse {
  data: {
    accountUpdateIdentification?: any;
  };
  errors?: IGraphQLError[];
}

export interface IMutationAccountSignOutResponse {
  data: {
    accountSignOut?: any;
  };
  errors?: IGraphQLError[];
}

export interface IMutationAccountPhoneConfirmRequest {
  phone: string;
}

export interface IMutationAccountPhoneConfirmResponse {
  data: {
    accountPhoneConfirm?: any;
  };
  errors?: IGraphQLError[];
}

export interface IMutationTransactionBuyRequest {
  code: string;
}

export interface IMutationTransactionBuyResponse {
  data: {
    transactionBuy?: any;
  };
  errors?: IGraphQLError[];
}

export interface IMutationTransactionCreditCardRequest {
  input: ICreditCardInput;
}

export interface IMutationTransactionCreditCardResponse {
  data: {
    transactionCreditCard?: boolean;
  };
  errors?: IGraphQLError[];
}

export interface IMutationAccountUpdatePhoneRequest {
  phone: string;
  code: string;
}

export interface IMutationAccountUpdatePhoneResponse {
  data: {
    accountUpdatePhone?: any;
  };
  errors?: IGraphQLError[];
}

export interface IMutationWithdrawalRequest {
  input: IWithdrawalInput;
}

export interface IMutationWithdrawalResponse {
  data: {
    withdrawal?: boolean;
  };
  errors?: IGraphQLError[];
}

export interface IMutationAccountIsNicknameExistRequest {
  nickname: string;
}

export interface IMutationAccountIsNicknameExistResponse {
  data: {
    accountIsNicknameExist?: boolean;
  };
  errors?: IGraphQLError[];
}

export interface IMutationAccountTimestampValidationRequest {
  timestamp: string;
}

export interface IMutationAccountTimestampValidationResponse {
  data: {
    accountTimestampValidation?: boolean;
  };
  errors?: IGraphQLError[];
}

export interface IMutationAttachToIotRequest {
  identityId: string;
}

export interface IMutationAttachToIotResponse {
  data: {
    attachToIot?: boolean;
  };
  errors?: IGraphQLError[];
}

export interface ISubscriptionOnRequestSenderRequest {
  senderId: string;
}

export interface ISubscriptionOnRequestSenderResponse {
  value?: {
    data: {
      onRequestSender?: IRequest;
    };
    errors?: IGraphQLError[];
  };
}

export interface ISubscriptionOnRequestOpponentRequest {
  opponentId: string;
}

export interface ISubscriptionOnRequestOpponentResponse {
  value?: {
    data: {
      onRequestOpponent?: IRequest;
    };
    errors?: IGraphQLError[];
  };
}

export interface ISubscriptionOnConversationMessageRequest {
  conversationId: string;
}

export interface ISubscriptionOnConversationMessageResponse {
  value?: {
    data: {
      onConversationMessage?: IConversationMessage;
    };
    errors?: IGraphQLError[];
  };
}

export interface ISubscriptionOnConversationMessageOpponentRequest {
  opponentId: string;
}

export interface ISubscriptionOnConversationMessageOpponentResponse {
  value?: {
    data: {
      onConversationMessageOpponent?: IConversationMessage;
    };
    errors?: IGraphQLError[];
  };
}

export const queryGetServices = async (
  params: IQueryGetServicesRequest,
  authMode: keyof typeof GRAPHQL_AUTH_MODE = "AMAZON_COGNITO_USER_POOLS"
) => {
  const response = await API.graphql({
    query: QueryGetServices,
    variables: params,
    authMode,
  });
  return (response as IQueryGetServicesResponse).data.getServices;
};

export const queryGetUsers = async (params: IQueryGetUsersRequest) => {
  const response = await API.graphql({
    query: QueryGetUsers,
    variables: params,
  });
  return response as IQueryGetUsersResponse;
};

export const queryGetReviewsByUserAsUser = async (
  params: IQueryGetReviewsByUserAsUserRequest,
  authMode: keyof typeof GRAPHQL_AUTH_MODE = "AMAZON_COGNITO_USER_POOLS"
) => {
  const response = await API.graphql({
    query: QueryGetReviewsByUserAsUser,
    variables: params,
    authMode,
  });
  return response as IQueryGetReviewsByUserAsUserResponse;
};

export const queryGetReviewsByUserAsServiceOwner = async (
  params: IQueryGetReviewsByUserAsServiceOwnerRequest,
  authMode: keyof typeof GRAPHQL_AUTH_MODE = "AMAZON_COGNITO_USER_POOLS"
) => {
  const response = await API.graphql({
    query: QueryGetReviewsByUserAsServiceOwner,
    variables: params,
    authMode,
  });
  return response as IQueryGetReviewsByUserAsServiceOwnerResponse;
};

export const queryGetNotifications = async () => {
  const response = await API.graphql({
    query: QueryGetNotifications,
    variables: {},
  });
  return response as IQueryGetNotificationsResponse;
};

export const queryGetNotification = async (
  params: IQueryGetNotificationRequest
) => {
  const response = await API.graphql({
    query: QueryGetNotification,
    variables: params,
  });
  return response as IQueryGetNotificationResponse;
};

export const queryGetNotificationsUnreadCount = async () => {
  const response = await API.graphql({
    query: QueryGetNotificationsUnreadCount,
    variables: {},
  });
  return response as IQueryGetNotificationsUnreadCountResponse;
};

export const queryGetReviewsByService = async (
  params: IQueryGetReviewsByServiceRequest,
  authMode: keyof typeof GRAPHQL_AUTH_MODE = "AMAZON_COGNITO_USER_POOLS"
) => {
  const response = await API.graphql({
    query: QueryGetReviewsByService,
    variables: { ...params },
    authMode,
  });
  return response as IQueryGetReviewsByServiceResponse;
};

export const queryGetReviewsByServiceToUser = async (
  params: IQueryGetReviewsByServiceToUserRequest,
  authMode: keyof typeof GRAPHQL_AUTH_MODE = "AMAZON_COGNITO_USER_POOLS"
) => {
  const response = await API.graphql({
    query: QueryGetReviewsByServiceToUser,
    variables: { ...params },
    authMode,
  });
  return response as IQueryGetReviewsByServiceToUserResponse;
};

export const queryGetUser = async (
  params: IQueryGetUserRequest,
  authMode: keyof typeof GRAPHQL_AUTH_MODE = "AMAZON_COGNITO_USER_POOLS"
) => {
  const response = await API.graphql({
    query: QueryGetUser,
    variables: { ...params },
    authMode,
  });
  return response as IQueryGetUserResponse;
};

export const queryGetRequests = async () => {
  const response = await API.graphql({
    query: QueryGetRequests,
    variables: {},
  });
  return response as IQueryGetRequestsResponse;
};

export const queryGetPreConversations = async (
  props: IQueryGetPreConversationsRequest
) => {
  const response = await API.graphql({
    query: QueryGetPreConversations,
    variables: { ...props },
  });
  return response as IQueryGetPreConversationsResponse;
};

export const queryGetPreConversation = async (
  props: IQueryGetPreConversationRequest
) => {
  const response = await API.graphql({
    query: QueryGetPreConversation,
    variables: { ...props },
  });
  return response as IQueryGetPreConversationResponse;
};

export const queryGetPreConversationByService = async (
  props: IQueryGetPreConversationByServiceRequest
) => {
  const response = await API.graphql({
    query: QueryGetPreConversationByService,
    variables: { ...props },
  });
  return response as IQueryGetPreConversationByServiceResponse;
};

export const queryGetService = async (
  props: IQueryGetServiceRequest,
  authMode: keyof typeof GRAPHQL_AUTH_MODE = "AMAZON_COGNITO_USER_POOLS"
) => {
  const response = await API.graphql({
    query: QueryGetService,
    variables: { ...props },
    authMode,
  });
  return response as IQueryGetServiceResponse;
};

export const queryGetOwnServices = async (
  props: IQueryGetOwnServicesRequest
) => {
  const response = await API.graphql({
    query: QueryGetOwnServices,
    variables: { ...props },
  });
  return response as IQueryGetOwnServicesResponse;
};

export const queryGetRequest = async (props: IQueryGetRequestRequest) => {
  const response = await API.graphql({
    query: QueryGetRequest,
    variables: { ...props },
  });
  return response as IQueryGetRequestResponse;
};

export const queryGetActiveRequest = async () => {
  const response = await API.graphql({
    query: QueryGetActiveRequest,
    variables: {},
  });

  return response as IQueryGetActiveRequestResponse;
};

export const queryGetRequestTwilioToken = async (
  props: IQueryGetRequestTwilioTokenRequest
) => {
  const response = await API.graphql({
    query: QueryGetRequestTwilioToken,
    variables: { ...props },
  });
  return response as IQueryGetRequestTwilioTokenResponse;
};

export const queryGetConversationMessages = async (
  props: IQueryGetConversationMessagesRequest
) => {
  const response = await API.graphql({
    query: QueryGetConversationMessages,
    variables: { ...props },
  });
  return response as IQueryGetConversationMessagesResponse;
};

export const queryGetUnreadMessages = async () => {
  const response = await API.graphql({
    query: QueryGetUnreadMessages,
    variables: {},
  });
  return response as IQueryGetUnreadMessagesResponse;
};

export const queryGetSales = async () => {
  const response = await API.graphql({ query: QueryGetSales, variables: {} });
  return response as IQueryGetSalesResponse;
};

export const queryGetAccount = async () => {
  const response = await API.graphql({ query: QueryGetAccount, variables: {} });
  return response as IQueryGetAccountResponse;
};

export const queryGetTransactions = async () => {
  const response = await API.graphql({
    query: QueryGetTransactions,
    variables: {},
  });
  return response as IQueryGetTransactionsResponse;
};

export const queryGetBanks = async () => {
  const response = await API.graphql({ query: QueryGetBanks, variables: {} });
  return response as IQueryGetBanksResponse;
};

export const queryGetBank = async (props: IQueryGetBankRequest) => {
  const response = await API.graphql({
    query: QueryGetBank,
    variables: { ...props },
  });
  return response as IQueryGetBankResponse;
};

export const queryGetWithdrawalRequest = async (
  props: IQueryGetWithdrawalRequestRequest
) => {
  const response = await API.graphql({
    query: QueryGetWithdrawalRequest,
    variables: { ...props },
  });
  return response as IQueryGetWithdrawalRequestResponse;
};

export const queryGetPreConversationsUnreadCount = async () => {
  const response = await API.graphql({
    query: QueryGetPreConversationsUnreadCount,
    variables: {},
  });
  return response as IQueryGetPreConversationsUnreadCountResponse;
};

export const queryGetRequestUnreadCount = async () => {
  const response = await API.graphql({
    query: QueryGetRequestUnreadCount,
    variables: {},
  });
  return response as IQueryGetRequestUnreadCountResponse;
};

export const mutationServiceLike = async (id: string) => {
  await API.graphql({ query: MutationServiceLike, variables: { id } });
};

export const mutationServiceDislike = async (id: string) => {
  await API.graphql({ query: MutationServiceDislike, variables: { id } });
};

export const mutationServiceView = async (id: string) => {
  await API.graphql({ query: MutationServiceView, variables: { id } });
};

export const mutationUserBlock = async (id: string) => {
  await API.graphql({ query: MutationUserBlock, variables: { id } });
};

export const mutationUserUnblock = async (id: string) => {
  await API.graphql({ query: MutationUserUnblock, variables: { id } });
};

export const mutationNotificationRead = async (id: string) => {
  await API.graphql({ query: MutationNotificationRead, variables: { id } });
};

export const mutationServiceCreate = async (
  params: IMutationServiceCreateRequest
) => {
  const response = await API.graphql({
    query: MutationServiceCreate,
    variables: { ...params },
  });
  return response as IMutationServiceCreateResponse;
};

export const mutationServiceUpdate = async (
  params: IMutationServiceUpdateRequest
) => {
  const response = await API.graphql({
    query: MutationServiceUpdate,
    variables: { ...params },
  });
  return response as IMutationServiceUpdateResponse;
};

export const mutationServiceDelete = async (
  params: IMutationServiceDeleteRequest
) => {
  const response = await API.graphql({
    query: MutationServiceDelete,
    variables: { ...params },
  });
  return response as IMutationServiceDeleteResponse;
};

export const mutationRequestCreate = async (
  params: IMutationRequestCreateRequest
) => {
  const response = await API.graphql({
    query: MutationRequestCreate,
    variables: { ...params },
  });
  return response as IMutationRequestCreateResponse;
};

export const mutationRequestApprove = async (
  params: IMutationRequestApproveRequest
) => {
  const response = await API.graphql({
    query: MutationRequestApprove,
    variables: { ...params },
  });
  return response as IMutationRequestApproveResponse;
};

export const mutationRequestCancel = async (
  params: IMutationRequestCancelRequest
) => {
  const response = await API.graphql({
    query: MutationRequestCancel,
    variables: { ...params },
  });
  return response as IMutationRequestCancelResponse;
};

export const mutationRequestReject = async (
  params: IMutationRequestRejectRequest
) => {
  const response = await API.graphql({
    query: MutationRequestReject,
    variables: { ...params },
  });
  return response as IMutationRequestRejectResponse;
};

export const mutationRequestCallApprove = async (
  params: IMutationRequestCallApproveRequest
) => {
  const response = await API.graphql({
    query: MutationRequestCallApprove,
    variables: { ...params },
  });
  return response as IMutationRequestCallApproveResponse;
};

export const mutationRequestCallReject = async (
  params: IMutationRequestCallRejectRequest
) => {
  const response = await API.graphql({
    query: MutationRequestCallReject,
    variables: { ...params },
  });
  return response as IMutationRequestCallRejectResponse;
};

export const mutationRequestCallFinish = async (
  params: IMutationRequestCallFinishRequest
) => {
  const response = await API.graphql({
    query: MutationRequestCallFinish,
    variables: { ...params },
  });
  return response as IMutationRequestCallFinishResponse;
};

export const mutationRequestTimeout = async (
  params: IMutationRequestTimeoutRequest
) => {
  const response = await API.graphql({
    query: MutationRequestTimeout,
    variables: { ...params },
  });
  return response as IMutationRequestTimeoutResponse;
};

export const mutationRequestReoffer = async (
  params: IMutationRequestReofferRequest
) => {
  const response = await API.graphql({
    query: MutationRequestReoffer,
    variables: { ...params },
  });
  return response as IMutationRequestReofferResponse;
};

export const mutationConversationReview = async (
  params: IMutationConversationReviewRequest
) => {
  await API.graphql({
    query: MutationConversationReview,
    variables: { ...params },
  });
};

export const mutationConversationMessage = async (
  params: IMutationConversationMessageRequest
) => {
  const response = await API.graphql({
    query: MutationConversationMessage,
    variables: { ...params },
  });
  return response as IMutationConversationMessageResponse;
};

export const mutationConversationMessageRead = async (
  params: IMutationConversationMessageReadRequest
) => {
  const response = await API.graphql({
    query: MutationConversationMessageRead,
    variables: { ...params },
  });
  return response as IMutationConversationMessageReadResponse;
};

export const mutationPreConversationCreate = async (
  params: IMutationPreConversationCreateRequest
) => {
  const response = await API.graphql({
    query: MutationPreConversationCreate,
    variables: { ...params },
  });
  return response as IMutationPreConversationCreateResponse;
};

export const mutationRegisterPushToken = async (
  params: IMutationRegisterPushTokenRequest
) => {
  await API.graphql({
    query: MutationRegisterPushToken,
    variables: { ...params },
  });
};

export const mutationRegisterPushVoipToken = async (
  params: IMutationRegisterPushVoipTokenRequest
) => {
  await API.graphql({
    query: MutationRegisterPushVoipToken,
    variables: { ...params },
  });
};

export const mutationResetPushTokens = async () => {
  await API.graphql({ query: MutationResetPushTokens, variables: {} });
};

export const mutationAccountUpdate = async (
  params: IMutationAccountUpdateRequest
) => {
  await API.graphql({ query: MutationAccountUpdate, variables: { ...params } });
};

export const mutationAccountUpdateIdentification = async (
  params: IMutationAccountUpdateIdentificationRequest
) => {
  await API.graphql({
    query: MutationAccountUpdateIdentification,
    variables: { ...params },
  });
};

export const mutationAccountSignOut = async () => {
  await API.graphql({ query: MutationAccountSignOut, variables: {} });
};

export const mutationAccountPhoneConfirm = async (
  params: IMutationAccountPhoneConfirmRequest
) => {
  await API.graphql({
    query: MutationAccountPhoneConfirm,
    variables: { ...params },
  });
};

export const mutationAccountUpdatePhone = async (
  params: IMutationAccountUpdatePhoneRequest
) => {
  await API.graphql({
    query: MutationAccountUpdatePhone,
    variables: { ...params },
  });
};

export const mutationAccountRemove = async () => {
  await API.graphql({ query: MutationAccountRemove, variables: {} });
};

export const mutationTransactionBuy = async (
  params: IMutationTransactionBuyRequest
) => {
  await API.graphql({
    query: MutationTransactionBuy,
    variables: { ...params },
  });
};

export const mutationTransactionCreditCard = async (
  params: IMutationTransactionCreditCardRequest
) => {
  const response = await API.graphql({
    query: MutationTransactionCreditCard,
    variables: { ...params },
  });
  return response as IMutationTransactionCreditCardResponse;
};

export const mutationAccountUpdateLastLogin = async () => {
  await API.graphql({ query: MutationAccountUpdateLastLogin, variables: {} });
};

export const mutationWithdrawal = async (
  params: IMutationWithdrawalRequest
) => {
  const response = await API.graphql({
    query: MutationWithdrawal,
    variables: { ...params },
  });
  return response as IMutationWithdrawalResponse;
};

export const mutationAccountIsNicknameExist = async (
  params: IMutationAccountIsNicknameExistRequest
) => {
  const response = await API.graphql({
    query: MutationAccountIsNicknameExist,
    variables: { ...params },
  });
  return response as IMutationAccountIsNicknameExistResponse;
};

export const mutationAccountIsNicknameExistForUnauth = async (
  params: IMutationAccountIsNicknameExistRequest
) => {
  const response = await API.graphql({
    query: MutationAccountIsNicknameExist,
    variables: { ...params },
    authMode: "API_KEY",
  });
  return response as IMutationAccountIsNicknameExistResponse;
};

export const mutationAccountTimestampValidationForUnauth = async (
  params: IMutationAccountTimestampValidationRequest
) => {
  const response = await API.graphql({
    query: MutationAccountTimestampValidation,
    variables: { ...params },
    authMode: "API_KEY",
  });
  return response as IMutationAccountTimestampValidationResponse;
};

export const mutationRequestsRead = async () => {
  await API.graphql({ query: MutationRequestsRead, variables: {} });
};

export const mutationAttachToIot = async (
  params: IMutationAttachToIotRequest
) => {
  const response = await API.graphql({
    query: MutationAttachToIot,
    variables: { ...params },
  });
  return response as IMutationAttachToIotResponse;
};

export const subscriptionOnRequestSender = async (
  params: ISubscriptionOnRequestSenderRequest
) => {
  const response = await API.graphql({
    query: SubscriptionOnRequestSender,
    variables: { ...params },
  });
  return response as Observable<ISubscriptionOnRequestSenderResponse>;
};

export const subscriptionOnRequestOpponent = async (
  params: ISubscriptionOnRequestOpponentRequest
) => {
  const response = await API.graphql({
    query: SubscriptionOnRequestOpponent,
    variables: { ...params },
  });
  return response as Observable<ISubscriptionOnRequestOpponentResponse>;
};

export const subscriptionOnConversationMessage = async (
  params: ISubscriptionOnConversationMessageRequest
) => {
  const response = await API.graphql({
    query: SubscriptionOnConversationMessage,
    variables: { ...params },
  });
  return response as Observable<ISubscriptionOnConversationMessageResponse>;
};

export const subscriptionOnConversationMessageOpponentMessage = async (
  params: ISubscriptionOnConversationMessageOpponentRequest
) => {
  const response = await API.graphql({
    query: SubscriptionOnConversationMessageOpponent,
    variables: { ...params },
  });
  return response as Observable<ISubscriptionOnConversationMessageOpponentResponse>;
};
